import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useState } from "react";

const ModalCreateNewFolder = (props) => {
  document
    .getElementById("create-new-folder-form")
    ?.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        props.setOnPressEnter(true);
      }
    });
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">{props.title}</h4>
          <form>
            <div className="mb-3">
              <p>New folder name</p>
              <input
                id="create-new-folder-form"
                type="text"
                className="form-control"
                onChange={props.folderName}
              ></input>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
          {props?.isActiveCreateNewFolderButton && (
            <button
              type="button"
              onClick={props.handleCreateNewFolder}
              className="large-button green"
            >
              CREATE NEW FOLDER
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default ModalCreateNewFolder;
